import { FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

const intlPrefix = `shoppingBag`;

export const AddAStrap = <FormattedMessage {...commonMessages.addAStrap} />;

export const Deposit = <FormattedMessage {...commonMessages.deposit} />;

export const PreOrderNote = (
  <FormattedMessage
    defaultMessage='You will receive an e-mail once the watch is available to pay the balance.'
    id={`${intlPrefix}.preOrderNote`}
  />
);
